import React, { useState } from "react";
import "./testemonial.css";
import { testimonialsData } from "../../data/testimonialsData";
import leftArrow from "../../assets/leftArrow.png";
import rightArrow from "../../assets/rightArrow.png";
import { motion } from "framer-motion";

const Testimonials = () => {
  const transition = {
    type: "spring",
    duration: 3,
  };

  const [selected, setSelected] = useState(0);
  const tLength = testimonialsData.length;

  return (
    <div className="testimonials">
      {/* Left Section */}
      <div className="left-t">
        <span>What Our Clients Say</span>
        <span className="stroke-text">Real</span>
        <span>Experiences</span>

        <motion.span
          key={selected}
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -100 }}
          transition={{ transition }}
        >
          {testimonialsData[selected].review}
        </motion.span>

        <span>
          <span style={{ color: "var(--orange)" }}>
            {testimonialsData[selected].name}
          </span>{" "}
          - {testimonialsData[selected].status}
        </span>
      </div>

      {/* Right Section */}
      <div className="right-t">
        <motion.div
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ ...transition, duration: 2 }}
        ></motion.div>
        <motion.div
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ ...transition, duration: 2 }}
        ></motion.div>

        <motion.img
          key={selected}
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -100 }}
          transition={{ ...transition }}
          src={testimonialsData[selected].image}
          alt="Client Testimonial"
        />

        {/* Navigation Arrows */}
        <div className="arrows">
          <img
            onClick={() => {
              selected === 0
                ? setSelected(tLength - 1) // Go to last image if at the first
                : setSelected((prev) => prev - 1); // Move to previous image
            }}
            src={leftArrow}
            alt="Previous Testimonial"
          />

          <img
            onClick={() => {
              selected === tLength - 1
                ? setSelected(0) // Go to first image if at the last
                : setSelected((prev) => prev + 1); // Move to next image
            }}
            src={rightArrow}
            alt="Next Testimonial"
          />
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
